import { Order, OrderStatus } from 'queries';

export const sumOrderWithStatus = (orders: Order[], status: OrderStatus) => {
  return orders
    .filter(order => order.status === status)
    .reduce((acc, order) => {
      if (!order.total) {
        return acc;
      }
      return acc + order.total;
    }, 0);
};

export const computeToBeBilledAmount = (orders: Order[] = []) => {
  return sumOrderWithStatus(orders, OrderStatus.COMPLETED);
};

export const computeAlreadyBilledAmount = (orders: Order[] = []) => {
  return sumOrderWithStatus(orders, OrderStatus.BILLED);
};
